import nj1stScience from "./nj1stScienceQuizContent";
import nj1stSocialStudies from "./nj1stSocialStudiesQuizContent";
import nj1stMath from "./nj1stMathQuizContent";
import nj1stOther from "./nj1stOtherQuizContent";

// 2nd Grade
import nj2ndScience from "./nj2ndScienceQuizContent";
import nj2ndSocialStudies from "./nj2ndSocialStudiesQuizContent";
import nj2ndMath from "./nj2ndMathQuizContent";
import nj2ndOther from "./nj2ndOtherQuizContent";

// 3rd Grade
import nj3rdScience from "./nj3rdScienceQuizContent";
import nj3rdSocialStudies from "./nj3rdSocialStudiesQuizContent";
import nj3rdMath from "./nj3rdMathQuizContent";
import nj3rdOther from "./nj3rdOtherQuizContent";

// 4th Grade
import nj4thScience from "./nj4thScienceQuizContent";
import nj4thSocialStudies from "./nj4thSocialStudiesQuizContent";
import nj4thMath from "./nj4thMathQuizContent";
import nj4thOther from "./nj4thOtherQuizContent";

// 5th Grade
import nj5thScience from "./nj5thScienceQuizContent";
import nj5thSocialStudies from "./nj5thSocialStudiesQuizContent";
import nj5thMath from "./nj5thMathQuizContent";
import nj5thOther from "./nj5thOtherQuizContent";
// ...import the rest as you add them

// Keep your existing keys ← these are what MapPage already uses
export const njtopicsMapBySubject = {
  // 1st Grade
  nj_1st_science: nj1stScience,
  nj_1st_socialstudies: nj1stSocialStudies,
  nj_1st_math: nj1stMath,
  nj_1st_other: nj1stOther,

  // 2nd Grade
  nj_2nd_science: nj2ndScience,
  nj_2nd_socialstudies: nj2ndSocialStudies,
  nj_2nd_math: nj2ndMath,
  nj_2nd_other: nj2ndOther,

  // 3rd Grade
  nj_3rd_science: nj3rdScience,
  nj_3rd_socialstudies: nj3rdSocialStudies,
  nj_3rd_math: nj3rdMath,
  nj_3rd_other: nj3rdOther,

  // 4th Grade
  nj_4th_science: nj4thScience,
  nj_4th_socialstudies: nj4thSocialStudies,
  nj_4th_math: nj4thMath,
  nj_4th_other: nj4thOther,

  // 5th Grade
  nj_5th_science: nj5thScience,
  nj_5th_socialstudies: nj5thSocialStudies,
  nj_5th_math: nj5thMath,
  nj_5th_other: nj5thOther,
  // ...add the rest
};
